<template>
  <div id="paginaSpeseComunicazione">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Spese Comunicazione</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropAnniRiferimento"
                  ref="dropAnniRiferimento"
                  :query="queryAnno"
                  :dataSource="annoRiferimentoList"
                  :index="annoIndex"
                  :fields="annoRiferimentoFields"
                  :change="onAnnoRiferimentoChange"
                  v-model="annoRiferimentoCorrente"
                  placeholder="Seleziona un Anno"
                ></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert
                  :show="alertADismissCountDown"
                  dismissible
                  variant="warning"
                  @dismissed="alertADismissCountDown = 0"
                  @dismiss-count-down="alertACountDownChanged"
                >
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert
                    variant="warning"
                    :max="alertADismissSecs"
                    :value="alertADismissCountDown"
                    height="4px"
                  />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <div id="GridParent">
                  <ejs-grid id="gridA" ref="gridA"
                    :dataSource="speseComunicazioneFullData"
                    :allowSorting="true" :sortSettings="gridA.sortOptions"
                    :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions"
                    :allowFiltering="true" :filterSettings="gridA.filterOptions"
                    :editSettings="gridA.editOptions" :height="gridA.height">
                    <e-columns>
                      <e-column
                        field="id" headerText="ID" :isPrimaryKey="true" width="100" ></e-column>
                      <e-column
                        field="tipologia" headerText="Tipologia" width="200" ></e-column>
                      <e-column
                        field="nomeFornitore" headerText="Fornitore" width="200"
                        ></e-column>
                      <e-column
                        field="data" headerText="Data"
                        :format="settings.formatoData" type="date"
                        width="200" ></e-column>
                      <e-column
                        field="importoTotale" headerText="Importo Tot." width="200" ></e-column>
                      <e-column
                        field="titoloSpettacolo" width="150" ></e-column>
                      <e-column
                        field="note" headerText="Note" width="300" ></e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </b-col>

              <b-col xl="12" md="12" class="mt-3">
                <h3>Riepilogo Spese Comunicazione</h3>
              </b-col>

              <!-- Button:  -->
              <b-col xl="12" md="12" class="mt-1">
                <ejs-button
                  id="aggiornaRiepilogoButton"
                  @click.native="aggiornaRiepilogo()"
                  >Aggiorna Riepilogo
                </ejs-button>
                <ejs-button
                  id="dowloadXls"
                  @click.native="downloadXls()">Download XLS</ejs-button>
              </b-col>

              <b-col xl="12" md="12" class="mt-1">
                <b-card tag="article" class="mb-2">
                  <b-card-header class="align-items-baseline">
                    <div>
                      <b-card-title>Totale Spese Comunicazione</b-card-title>
                      <b-card-text class="mb-0" />
                    </div>
                  </b-card-header>
                  <b-card-body class="mb-0">
                    <!-- card body -->
                    <b-row>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totalePreventivoPriv" class="h5"
                          >Totale Preventivo</label
                        >
                        <ejs-numerictextbox
                          id="totalePreventivoPriv"
                          v-model="totalePreventivoPriv"
                          floatLabelType="Never"
                          cssClass=""
                          format="€ ###.##"
                          placeholder="Preventivo Priv"
                          showSpinButton="false"
                          showClearButton="true"
                          :readonly="true"
                        />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totaleConsuntivoPriv" class="h5"
                          >Totale Consuntivo</label
                        >
                        <ejs-numerictextbox
                          id="totaleConsuntivoPriv"
                          v-model="totaleConsuntivoPriv"
                          floatLabelType="Never"
                          cssClass=""
                          format="€ ###.##"
                          placeholder="Consuntivo Priv"
                          showSpinButton="false"
                          showClearButton="true"
                          :readonly="true"
                        />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="scostamentoPriv" class="h5"
                          >Scostamento</label
                        >
                        <ejs-numerictextbox
                          id="scostamentoPriv"
                          v-model="scostamentoPriv"
                          floatLabelType="Never"
                          cssClass=""
                          format="€ ###.##"
                          placeholder="Preventivo - Consuntivo"
                          showSpinButton="false"
                          showClearButton="true"
                          :readonly="true"
                        />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="scostamentoPercPriv" class="h5"
                          >Scostamento %</label
                        >
                        <ejs-numerictextbox
                          id="scostamentoPercPriv"
                          v-model="scostamentoPercPriv"
                          floatLabelType="Never"
                          cssClass=""
                          format="###.##"
                          placeholder="Scostamento %"
                          showSpinButton="false"
                          showClearButton="true"
                          :readonly="true"
                        />
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioSpesaComunicazione ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogA"
      ref="dialogA"
      :header="dialogA.header"
      :buttons="dialogA.buttons"
      :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon"
      :close="dialogAClose"
      :open="dialogAOpen"
      :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings"
      :isModal="dialogA.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Dati Spesa Comunicazione">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Spesa Comunicazione</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox
                        id="id"
                        v-model="speseComunicazioneActiveData.id"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="id"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipologia" class="h5">Tipologia</label>
                      <ejs-dropdownlist
                        id="tipologia"
                        ref="tipologia"
                        :query="queryAnno"
                        :dataSource="tipologiaList"
                        :fields="tipologiaFields"
                        v-model="speseComunicazioneActiveData.tipologia"
                        placeholder="Seleziona una tipologia"
                      ></ejs-dropdownlist>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="spesaGenerica" class="h5 mr-1"
                          >Spesa Generica</label
                        >
                        <ejs-checkbox
                          id="spesaGenerica"
                          v-model="speseComunicazioneActiveData.spesaGenerica"
                          :checked="speseComunicazioneActiveData.spesaGenerica"
                          name="spesaGenerica"
                        />
                      </b-row>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="annoSpettacolo" class="h5"
                        >Anno Spettacolo</label
                      >
                      <ejs-dropdownlist
                        id="annoSpettacolo"
                        ref="annoSpettacolo"
                        :query="queryAnno"
                        :dataSource="annoSpettacoloList"
                        :fields="annoSpettacoloFields"
                        :change="onAnnoSpettacoloChange"
                        v-model="speseComunicazioneActiveData.annoSpettacolo"
                        placeholder="Seleziona un Anno"
                      ></ejs-dropdownlist>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dropSpettacoli" class="h5">Spettacolo</label>
                      <ejs-dropdownlist
                        id="dropSpettacoli"
                        ref="dropSpettacoli"
                        :query="querySpettacoli"
                        :dataSource="spettacoliFullData"
                        :index="spettacoliIndex"
                        :fields="elencoSpettacoliFields"
                        v-model="speseComunicazioneActiveData.spettacolo"
                        placeholder="Seleziona uno Spettacolo"
                        :allowFiltering="true"
                        :filtering="spettacoloFiltering"
                      ></ejs-dropdownlist>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="Fornitore" class="h5">Fornitore</label>
                      <ejs-dropdownlist
                        id="fornitore" ref="fornitore"
                        v-model="speseComunicazioneActiveData.fornitore"
                        :dataSource="fornitoriList" :fields="fornitoriFields"
                        :allowFiltering="true" :filtering="fornitoriFiltering"
                        :itemTemplate="itemTemplate" :valueTemplate="valueTemplate"
                        placeholder="Scegli fornitore"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="data" class="h5">Data</label>
                      <ejs-datepicker
                        id="data"
                        v-model="speseComunicazioneActiveData.data"
                        :format="settings.formatoDatepicker"
                        placeholder="Data"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="importoTotale" class="h5"
                        >Importo Totale</label
                      >
                      <ejs-numerictextbox
                        id="importoTotale"
                        v-model="speseComunicazioneActiveData.importoTotale"
                        format="€ ###.##"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Importo Totale"
                        :showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: speseComunicazioneActiveData.note  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox
                        id="note"
                        v-model="speseComunicazioneActiveData.note"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Note"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="3"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dataScadenzaPagamento" class="h5"
                        >Data Scadenza Pagamento</label
                      >
                      <ejs-datepicker
                        id="dataScadenzaPagamento"
                        v-model="speseComunicazioneActiveData.dataScadenzaPagamento"
                        :format="settings.formatoData"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="pagato" class="h5">Pagato</label>
                      <ejs-dropdownlist
                        id="pagato"
                        v-model="speseComunicazioneActiveData.pagato"
                        :dataSource="pagatoList"
                        :fields="pagatoFields"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dataPagamento" class="h5"
                        >Data Pagamento</label
                      >
                      <ejs-datepicker
                        id="dataPagamento"
                        v-model="speseComunicazioneActiveData.dataPagamento"
                        :format="settings.formatoData"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="riferimentoContabile" class="h5"
                        >Riferimento Contabile</label
                      >
                      <ejs-textbox
                        id="riferimentoContabile"
                        v-model="speseComunicazioneActiveData.riferimentoContabile"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="riferimentoContabile"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api

const apiSpeseComunicazioneUrl = "/demo/api/spesacomunicazione";
const apiSpeseComunicazioneAnnoUrl = "/demo/api/spesacomunicazione/anno";
const apiSpeseComunicazioneExportXls = "/demo/api/spesacomunicazione/export_xls";

const apiFornitoriUrl = "/demo/api/soggetto/fornitori";
const apiSpettacoliRicercaUrl = "/demo/api/spettacolo/ricerca";
const apiBilancioCocciaRicercaAnnoUrl = "/demo/api/bilanciococcia/ricercaAnno";

var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='ragioneSociale'>{{data.ragioneSociale}}</span><span style='margin-right:3em;display:inline-block;'>&nbsp;&nbsp;</span><span class ='partitaIva'>{{data.partitaIva}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      dataOggi: new Date(),
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },

      speseComunicazioneFullData: [],
      speseComunicazioneActiveId: 0,
      speseComunicazioneActiveData: {},
      id_spettacolo: 0,
      totalePreventivoPriv: null,
      totaleConsuntivoPriv: null,
      scostamentoPriv: null,
      scostamentoPercPriv: null,

      // per inizializzazione dropdown a null
      initIndex: -1,
      //fornitori
      fornitoriList: [],
      fornitoriFields: { text: "denominazione", value: "id" },
      //spettacoli
      spettacoliFullData: [],
      elencoSpettacoliFields: { value: "id", text: "titolo" },
      spettacoliIndex: -1,
      // tipo pagamento
      tipoList: [
        { label: "Bonifico", val: "bonifico" },
        { label: "Emolumento", val: "emolumento" },
      ],
      tipoFields: { text: "label", value: "val" },

      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },

      annoRiferimentoList: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      annoRiferimentoFields: { value: "val", text: "label" },
      annoIndex: -1,
      queryAnno: null,
      querySpettacoli: null,
      annoRiferimentoCorrente: null,
      annoSpettacoloList: [
        { label: "2022", val: "2022" },
        { label: "2023", val: "2023" },
        { label: "2024", val: "2024" },
        { label: "2025", val: "2025" },
        { label: "2026", val: "2026" },
      ],
      annoSpettacoloFields: { value: "val", text: "label" },
      tipologiaList: [
        { label: "Affissioni", val: "Affissioni" },
        { label: "Manifesti", val: "Manifesti" },
        { label: "Spedizioni", val: "Spedizioni" },
        { label: "Volantini", val: "Volantini" },
        { label: "Volantinaggio", val: "Volantinaggio" },
        { label: "Libretti", val: "Libretti" },
        { label: "Pubblicità", val: "Pubblicità" },
        { label: "Social", val: "Social" },
        { label: "Videomaker", val: "Videomaker" },
        { label: "Fotografo", val: "Fotografo" },
        { label: "Bus", val: "Bus" },
        { label: "Ncc", val: "Ncc" },
        { label: "Altro", val: "Altro" },
      ],
      tipologiaFields: { value: "val", text: "label" },

      // pagato
      pagatoList: [
        { label: "Si", id: "si" },
        { label: "No", id: "no" },
        { label: "Acconto", id: "acconto" },
      ],
      pagatoFields: { text: "label", value: "id" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
        isModal: false,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo",
            tooltipText: "Crea nuova spesa comunicazione",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica spesa comunicazione",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella spesa comunicazione",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          "Search",
        ],
        sortOptions: { columns: [{ field: "data", direction: "Ascending" }] },
      },
    };
  },
  created() {
    console.log("Pagina Spese Comunicazione Creata");
    // inizializzazione elenchi dal backend
    // chiamate API

    if (localStorage.getItem("userData") !== null) {
      console.log("Recupero elenco spese comunicazione dal backend");
      // fornitori
      useJwt.get(apiFornitoriUrl).then((d) => {
        if (d.status != 200) {
          console.log("REDIRIGERE A LOGIN");
          alert("Effettua di nuovo il login");
        } else {
          // console.log(d.status);
          console.log("FORNITORI")
          console.log(d.data);
          this.fornitoriList = d.data;
        }
      });
    } else {
      console.log("Non trovo UserData, prova ancora");
    }
  },

  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add('disablegrid')
    document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropAnniRiferimento
    this.$refs.dropAnniRiferimento.ej2Instances.focusIn()
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    fornitoriFiltering: function (e) {
      var searchData = this.fornitoriList;
      var query = new Query();
      query = e.text != "" ? query.where("denominazione", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    spettacoloFiltering: function (e) {
      var searchData = this.spettacoliFullData;
      var query = new Query();
      query =
        e.text != "" ? query.where("titolo", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    aggiornaOggettiCollegati: function() {
      this.speseComunicazioneFullData.forEach(obj =>{
        // trova fornitore
        let i = this.fornitoriList.findIndex((x) => x.id === (+obj.fornitore))
        if (i > 0) {
          console.log(this.fornitoriList[i].denominazione)
          obj.nomeFornitore = this.fornitoriList[i].denominazione
        } else {
          console.log("fornitore non trovato")
        }
        // trova spettacolo
        i = this.spettacoliFullData.findIndex((x) => x.id === obj.spettacolo)
        if (i > 0) {
          obj.titoloSpettacolo = this.spettacoliFullData[i].titolo
        }
      })
    },
    async onAnnoRiferimentoChange (e) {
      console.log("Change");
      console.log("Recupero elenco spese comunicazione per l'anno selezionato");
      const datiDaInviare = { anno: this.annoRiferimentoCorrente };
      const stagioneSpettacolo = { stagione: this.annoRiferimentoCorrente };
      await useJwt.post(apiSpettacoliRicercaUrl, stagioneSpettacolo).then((d) => {
        this.spettacoliFullData = d.data;
      });
      useJwt.post(apiSpeseComunicazioneAnnoUrl, datiDaInviare).then((d) => {
        console.log("spese comunicazione")
        console.log(d.data)
        this.speseComunicazioneFullData = d.data
        this.aggiornaOggettiCollegati()
        this.$refs.gridA.$el.classList.remove('disablegrid')
        document.getElementById("GridParent").classList.remove('wrapper')
      });
      // Azzero i totali
      this.totalePreventivoPriv = 0;
      this.totaleConsuntivoPriv = 0;
      this.scostamentoPriv = 0;
      this.scostamentoPercPriv = null;
    },
    onAnnoSpettacoloChange: function (e) {
      console.log("Change Anno Spettacolo");
      const stagioneSpettacolo = {
        stagione: this.speseComunicazioneActiveData.annoSpettacolo,
      };
      useJwt.post(apiSpettacoliRicercaUrl, stagioneSpettacolo).then((d) => {
        // console.log("SPETTACOLI");
        // console.log(d.data);
        this.spettacoliFullData = d.data;
      });
    },
    downloadXls: function(compact) {
      let datiDaInviare = {
          anno: this.annoRiferimentoCorrente,
      }
      /// AA DA PROVARE
      useJwt.post(apiSpeseComunicazioneExportXls, datiDaInviare, { responseType: "blob" }).then((r)=>{
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore Anno non selezionato")
      });
    },
    async aggiornaRiepilogo(args) {
      console.log("Aggiorna Riepilogo");
      this.totalePreventivoPriv = 0;
      this.totalePreventivoIst = 0;

      // lettura dei valori correnti
      const r = await useJwt
        .post(apiBilancioCocciaRicercaAnnoUrl, {
          anno: this.annoRiferimentoCorrente,
        })
        .then((d) => {
          console.log("BILANCIO COCCIA");
          console.log(d.data);
          console.log(d.data["error"]);
          if (d.data["error"] == false) {
            this.totalePreventivoPriv += +d.data["prevAcquistoMatPubbl"];
            this.totalePreventivoPriv += +d.data["prevSpesePubblicita"];

            return false;
          }

          return true;
        });
      if (r) {
        this.makeToast(
          "primary",
          "Attenzione",
          "Bilancio mancante per l'anno selezionato"
        );
      }
      // lettura
      this.totaleConsuntivoPriv = 0;
      this.speseComunicazioneFullData.forEach((obj) => {
        this.totaleConsuntivoPriv += Number(obj.importoTotale);
      });

      this.scostamentoPriv = this.totaleConsuntivoPriv - this.totalePreventivoPriv;
      if (this.totalePreventivoPriv > 0 && this.totaleConsuntivoPriv > 0) {
        this.scostamentoPercPriv = (100 * this.totaleConsuntivoPriv) / this.totalePreventivoPriv;
      } else {
        this.scostamentoPercPriv = null;
      }

    },

    // per dialogA
    dialogAOpen(args) {
      console.log("Apertura dialogA");

      this.speseComunicazioneActiveData.spettacolo = this.id_spettacolo;
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogAClose() {
      console.log("Chiusura dialogA");
      this.dialogA.tabAdialogAIndex = 0;
      //console.log(this.speseComunicazioneActiveData);
    },
    async dialogAOk() {
      let error = false
      console.log("Cliccato bottone OK di dialogA");
      // salvataggio informazioni in remoto
      if (this.speseComunicazioneActiveId === 0) {
        // salvataggio in caso di new
        error = await useJwt
          .post(apiSpeseComunicazioneUrl, this.speseComunicazioneActiveData)
          .then((res) => {
            // TODO: gestione errore creazione
            if (res.status == 200 || res.status == 201) {
              this.makeToast("primary", "Successo", "Creazione della spesa comunicazione OK");
            }
            console.log("SPESA COMUNICAZIONE CREATA");
            console.log(res.data);
            // mi segno ID elemento appena creato
            this.speseComunicazioneActiveId = res.data.id;
            return false; // restituisci contesto per permettere aggiornamento grid
          }).catch(error => {
            let messaggio = ""
            if (error.response) {
              //console.log(error.response.data)
              let chiavi = Object.keys(error.response.data)
              // console.log(error.response.data['soggetto'])
              // console.log(error.response.data['tipologia'])
              chiavi.forEach((k) => {
                messaggio += `${k}: ${error.response.data[k]}`
                messaggio += "\n"
              })
              console.log(messaggio)
              this.makeToast("primary", "ERRORE", messaggio);
            }
            return true
          })
          console.log(`errore ${error}`)
          if (error == false) {
            const datiDaInviare = {
              anno: this.annoRiferimentoCorrente,
            };
            useJwt.post(apiSpeseComunicazioneAnnoUrl, datiDaInviare)
                  .then((res) => {
                    console.log(
                      "Aggiornamento gridA con l'aggiunta di una spesa comunicazione"
                    );
                    this.speseComunicazioneFullData = res.data;
                    this.speseComunicazioneFullData = [...this.speseComunicazioneFullData];
                    this.aggiornaOggettiCollegati()
                  });
            // nascondi dialog solo se creazione avvenuta con successo
            this.$refs.dialogA.hide();
          }
      } else {
        // salvataggio in caso di edit
        const editUrl = `${apiSpeseComunicazioneUrl}/${this.speseComunicazioneActiveId}`;
        error = await useJwt
          .patch(editUrl, this.speseComunicazioneActiveData)
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.makeToast(
                "primary",
                "Successo",
                "Modifica della spesa comunicazione OK"
              );
            }
            console.log(res.status);
            return false; // restituisci contesto per permettere aggiornamento gridA
          }).catch(error => {
            let messaggio = ""
            if (error.response) {
              //console.log(error.response.data)
              let chiavi = Object.keys(error.response.data)
              // console.log(error.response.data['soggetto'])
              // console.log(error.response.data['tipologia'])
              chiavi.forEach((k) => {
                messaggio += `${k}: ${error.response.data[k]}`
                messaggio += "\n"
              })
              console.log(messaggio)
              this.makeToast("primary", "ERRORE", messaggio);
            }
            return true
          })
          console.log(`errore ${error}`)

          if (error == false) {
            const datiDaInviare = {
              anno: this.annoRiferimentoCorrente,
            };
            useJwt.post(apiSpeseComunicazioneAnnoUrl, datiDaInviare)
              .then((res) => {
                console.log("Aggiornamento gridA con la modifica di una spesa comunicazione")
                this.speseComunicazioneFullData = res.data
                this.speseComunicazioneFullData = [...this.speseComunicazioneFullData]
                this.aggiornaOggettiCollegati()
              });
            this.$refs.dialogA.hide();
          }
      }
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        this.dialogA.header = "Nuova Spesa Comunicazione";
        const oggi = new Date();
        this.speseComunicazioneDefaultData = {
          id: 0,
          anno: this.annoRiferimentoCorrente,
          tipologia: null,
          annoSpettacolo: null,
          spettacolo: 0,
          fornitore: null,
          data: null,
          importoTotale: null,
          dataScadenzaPagamento: null,
          pagato: null,
          dataPagamento: null,
          riferimentoContabile: null,
          note: null,
          spesaGenerica: false,
        };
        this.speseComunicazioneActiveData = this.speseComunicazioneDefaultData;
        console.log("Premuto pulsante creazione nuova spesa comunicazione da gridA");
        // console.log(this.speseComunicazioneActiveData);
        this.speseComunicazioneActiveId = 0;
        this.$refs.dialogA.show(true);
      } else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica spesa comunicazione da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          this.speseComunicazioneActiveId = selectedRow[0].id;
          console.log("gridA, Id selezionato:");
          console.log(this.speseComunicazioneActiveId);
          const i = this.speseComunicazioneFullData.findIndex((x) => x.id === this.speseComunicazioneActiveId);
          if (i >= 0) {
            console.log("id spettacolo");
            this.id_spettacolo = this.speseComunicazioneFullData[i]["spettacolo"];
            console.log(this.id_spettacolo);
            this.speseComunicazioneActiveData = this.speseComunicazioneFullData[i];
            this.speseComunicazioneActiveData.spettacolo = this.id_spettacolo;
            this.id_fornitore = this.speseComunicazioneFullData[i]["fornitore"];
            this.speseComunicazioneActiveData.fornitore = +this.id_fornitore;
            console.log(`fornitore ${this.id_fornitore}`);
            console.log("spesa comunicazione active data on edit");
            console.log(this.speseComunicazioneActiveData);
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          console.log(err);
          this.alertAShow();
        }

        this.$refs.dialogA.show(true);
      } else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina spesa comunicazione da gridA");
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          const deleteUrl = `${apiSpeseComunicazioneUrl}/${deletedElementId}`;
          this.$refs.gridA.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
          });
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
  computed: {
    // importoTotale: {
    //   get: function () {
    //     return this.speseComunicazioneActiveData.importoAcconto + this.speseComunicazioneActiveData.importoSaldo;
    //   },
    //   set: function () {
    //     // non usato
    //   },
    // },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
